import React from "react"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import FineTable from "./FineTable"

export default function FineList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Fines")} />
        <FineTable />
      </div>
    </div>
  )
}
